const x = {
  // max is deprecated, use larger instead
  max: "1600px",
  larger: "1600px",
  large: "1400px",
  normal: "1280px",
  small: "992px",
  smallest: "800px"
}, p = {
  min: "8px",
  xs: "12px",
  sm: "16px",
  md: "24px",
  lg: "32px",
  xl: "40px",
  "2xl": "48px",
  "3xl": "56px",
  "4xl": "64px",
  "5xl": "72px",
  "6xl": "80px",
  "7xl": "96px",
  "8xl": "104px",
  max: "120px",
  maxWidth: {
    ...x
  }
};
export {
  x as maxWidth,
  p as spacing
};
//# sourceMappingURL=spacing.js.map
